<div class="w-full flex" [ngClass]="{ 'items-start': !isComment || isNotification }">
  <div class="relative max-w-full flex items-center cursor-pointer" *ngIf="!isComment || isNotification">
    <!-- ? Image -->
    <ng-container *ngIf="
        User?.userType === 1 || User?.userType === 4 || User?.userType === 5;
        else publisherImageLinkTemplate
      ">
      <a class="relative rounded-full w-10 min-w-10 h-10 md:w-12 md:min-w-12 md:h-12" [ngClass]="{
          '!w-12 !h-12': size === 'large',
        }" [routerLink]="[
          User?.userType === 5 ? routes.club : routes.profile,
          User?.userType === 5 ? User?.userId : User?.userName
        ]">
        <!-- ? Actor Image -->
        <ng-container *ngTemplateOutlet="
              imageTemplate;
              context: {
                size: size,
                alt: User?.userFullname,
                hasPhoto: User?.userHasPhoto || true,
                routeId:
                (User?.userType === userTypeEnum.Publisher || User?.userType === userTypeEnum.Author || User?.userType === userTypeEnum.Club)
                    ? User?.userId
                    : User?.userName,
                id: User?.userId,
                link:routes.profile,
                imageType:
                  User?.userType === userTypeEnum.Publisher
                    ? imageType.publisherAvatar
                    : User?.userType === userTypeEnum.Author
                    ? imageType.authorAvatar
                    : User?.userType === userTypeEnum.Club
                    ? imageType.clubAvatar
                    : imageType.userAvatar
              }
            ">
        </ng-container>
        <!-- ? Image Icon -->
        <div class="w-6 h-6 flex items-center justify-center absolute bottom-0 right-0 text-gray-800"
          *ngIf="User?.includeImageIcon">
          <span
            class="text-xs border-3 border-white rounded-full w-full h-full flex items-center justify-center text-gray-800"
            [ngClass]="
                User?.activityVerb
                  | userImageIcon : User?.activityObjectType : inside
              "></span>
        </div>
        <span class="w-3 h-3 rounded-full absolute bottom-0 right-0 bg-red-700 z-50" *ngIf="notificationBadge"></span>
      </a>
    </ng-container>
  </div>

  <span class="mt-[0.35rem] comment-filled icon text-sm text-gray-500 ml-1" *ngIf="isComment && !isNotification"></span>

  <div class="grow flex flex-wrap items-center" [ngClass]="{ 'pr-1 sm:pr-2': !isComment || isNotification }">
    <!-- ? Date -->
    <p class="w-full mb-2">
      <!-- ? Actor -->
      <ng-container *ngIf="
          User?.userType === 1 || User?.userType === 4 || User?.userType === 5;
          else publisherLinkTemplate
        ">
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 20">
          <ng-container *ngIf="!isClubAdminsActivity">شما توسط</ng-container>
          <ng-container *ngIf="isClubAdminsActivity">
            <a class="cursor-pointer" [routerLink]="[routes.profile, User?.affectedUser?.userName]">
              <span class="text-gray-800 text-sm md:text-base font-medium">
                {{ User?.affectedUser?.fullName }}
              </span>
            </a>
            توسط
          </ng-container>
        </span>
        <ng-container *ngIf="User?.activityVerb == 27 && isClubAdminsActivity">
          <span class="text-sm md:text-base text-gray-500">
            درخواست عضویت
            <a class="cursor-pointer" [routerLink]="[routes.profile, User?.affectedUser?.userName]">
              <span class="text-sm md:text-base font-medium text-gray-800">
                {{ User?.affectedUser?.fullName }}
              </span>
            </a>
            در باشگاه کتابخوانی توسط
          </span>
        </ng-container>
        <a *ngIf="User.activityVerb !== 34" class="cursor-pointer" [routerLink]="[
            User?.userType === 5 ? routes.club : routes.profile,
            User?.userType === 5 ? User?.userId : User?.userName
          ]">
          <span class="text-xs md:text-sm font-medium cursor-pointer text-gray-900" [ngClass]="{
              '!text-sm !text-gray-600 !font-medium': isComment && !isNotification,
              'max-md:!text-sm md:!text-base font-medium':
                !(isComment && !isNotification) && size !== 'small',
              'line-clamp-1': reviewSlider
            }">
            {{ User?.userFullname }}
          </span>
        </a>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 20">به باشگاه کتابخوانی</span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 21">درخواست عضویت در باشگاه
          کتابخوانی
        </span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 22">کتاب</span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 23">دورۀ مطالعاتی روی کتاب
        </span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 26">رویداد</span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 27">
          <ng-container *ngIf="!isClubAdminsActivity">
            درخواست عضویت شما در باشگاه کتابخوانی
          </ng-container>
          <ng-container *ngIf="isClubAdminsActivity">
            پذیرفته شد.
          </ng-container>
        </span>

        <!-- ? Club polled -->
        <a *ngIf="User?.activityVerb == 24" class="w-auto cursor-pointer" [routerLink]="[routes.club, User?.userId]">
          <span class="text-sm md:text-base font-medium cursor-pointer text-gray-800" [ngClass]="{
              'text-gray-500': isComment && !isNotification,
              'text-sm': isComment && !isNotification,
              'text-sm md:text-base font-medium':
                !(isComment && !isNotification) && size !== 'small',
              'line-clamp-1': reviewSlider
            }">
            {{ User?.activityText }}
          </span>
        </a>

        <!-- ? Club meetings -->
        <a *ngIf="
            User?.activityVerb == 20 ||
            User?.activityVerb == 21 ||
            User?.activityVerb == 22 ||
            User?.activityVerb == 23 ||
            User?.activityVerb == 26 ||
            User?.activityVerb == 27
          " class="cursor-pointer" [routerLink]="[
            User?.activityVerb == 26
              ? routes.meeting
              : User?.activityVerb == 22 || User?.activityVerb == 23
              ? routes.book
              : routes.club,
            User?.activityObjectId
          ]" [queryParams]="{ clubId: User?.userId }">
          <span class="text-sm md:text-base font-medium cursor-pointer text-gray-800" [ngClass]="{
              'text-gray-500': isComment && !isNotification,
              'text-sm': isComment && !isNotification,
              'text-sm md:text-base font-medium':
                !(isComment && !isNotification) && size !== 'small',
              'line-clamp-1': reviewSlider
            }">
            {{ User?.activityText }}
          </span>
        </a>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 20">
          دعوت
          <ng-container *ngIf="!isClubAdminsActivity">شدید.</ng-container>
          <ng-container *ngIf="isClubAdminsActivity">شد.</ng-container>
        </span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 21">را دارد.</span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 22">را در این دورۀ خود برگزار
          می‌کند.</span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 23">را به پایان رساند.</span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 26">را برگزار می‌کند.</span>
        <span class="text-sm md:text-base text-gray-500" *ngIf="User?.activityVerb == 27 && !isClubAdminsActivity">را
          پذیرفت.</span>

        <span class="text-sm md:text-base cursor-pointer text-gray-800 mr-1"
          *ngIf="User?.activityVerb === 3 && User?.totalLikesCount > 1" (click)="otherPeopleClicked()">
          و {{ User?.totalLikesCount - 1 }} نفر دیگر
        </span>

        <span class="text-sm md:text-base cursor-pointer text-gray-800 mr-1"
          *ngIf="User?.activityVerb === 32 && User?.totalLikesCount > 1" (click)="otherPeopleClicked()">
          و {{ User?.totalLikesCount - 1 }} نفر دیگر
        </span>
      </ng-container>

      <!-- ? Activity Text (Except club join request accepted and club invited and meeting created) -->
      <ng-container *ngIf="
          (User?.activityVerb != 20 &&
            User?.activityVerb != 21 &&
            User?.activityVerb != 22 &&
            User?.activityVerb != 23 &&
            User?.activityVerb != 24 &&
            User?.activityVerb != 26 &&
            User?.activityVerb != 27) ||
          (User?.activityVerb === 3 && User?.totalLikesCount <= 1)
        ">
        <a class="text-gray-500 hover:text-black" *ngIf="User?.activityText?.length > 0" [routerLink]="[
            User?.activityVerb
              | feedLinks
                : User?.activityId
                : User?.activityObjectType
                : User?.activityObjectId
                : User?.userName
          ]" [fragment]="commentId" [ngClass]=" { 'mr-1' : User.activityVerb !==34, 'cursor-pointer' :
          (User?.activityVerb | textClickable:User?.activityObjectType), }">

          <span class="text-xs md:text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-50" [ngClass]="{
            '!text-sm': isComment && !isNotification,
            'max-md:!text-sm md:!text-base':
              !(isComment && !isNotification) && size !== 'small',
          }">
            <!-- 'text-sm md:!text-base !text-gray-400 hover:!text-gray-900': isNotification, -->
            {{ User?.activityText }}
          </span>
        </a>
      </ng-container>

      <!-- ? Other Activities -->
      <a class="cursor-pointer text-xs md:text-sm mr-1 text-gray-500 hover:text-gray-900 dark:hover:text-gray-50"
        *ngIf="User?.hasOtherObjects && User?.bookId" [routerLink]="[routes.history, User?.bookId]"
        [queryParams]="{ user: User?.userName }">
        (تاریخچۀ مطالعه)
      </a>
    </p>

    <!-- ? Date -->
    <ng-container *ngIf="displayDate">
      <div class="w-full flex items-center">
        <jalali-date [date]="User?.activityDate"> </jalali-date>

        <ng-container *ngIf="User?.textReadTime">
          <div class="grow mr-1 flex justify-start items-center">
            <span class="icon timer-regular text-gray-500 text-xs"></span>
            <span class="text-[.71rem] sm:text-xs text-gray-500">
              {{ User?.textReadTime }}
            </span>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #publisherImageLinkTemplate>
  <a [routerLink]="[routes.profile, User?.userId]" [queryParams]="{isPublisher : true}" class="relative avatar-md">
    <img loading="lazy" width="48" height="48" class="rounded-full w-full h-full"
      onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'"
      [src]="User?.userId | userImage : User?.userType : User?.userHasPhoto" [alt]="User?.userFullname" />
    <span
      class="rounded-full w-6 h-6 absolute flex items-center justify-center bottom-0 right-0 overflow-hidden text-gray-500"
      *ngIf="User?.includeImageIcon">
      <span
        class="text-xs border-3 border-white rounded-full w-full h-full flex items-center justify-center text-gray-500"
        [ngClass]="
          User?.activityVerb | userImageIcon : User?.activityObjectType : inside
        "></span>
    </span>

    <!-- <span class="bg-red-700 w-3 h-3 rounded-full absolute bottom-0 right-0" *ngIf="notificationBadge"></span> -->
  </a>
</ng-template>

<ng-template #publisherLinkTemplate>
  <a class="cursor-pointer text-gray-700" [routerLink]="[routes.profile, User?.userId]"
    [queryParams]="{ isPublisher: true }">
    <span class="text-sm md:text-base font-medium list-none text-gray-800" [ngClass]="{
        'text-gray-500': isComment && !isNotification,
        'text-sm': isComment && !isNotification,
        'line-clamp-1': reviewSlider
      }">
      {{ User?.userFullname }}
    </span>
  </a>
</ng-template>

<!-- ? Actor Image -->
<ng-template #imageTemplate let-link="link" let-imageType="imageType" let-id="id" let-alt="alt" let-hasPhoto="hasPhoto"
  let-routeId="routeId" let-size="size">
  <img loading="lazy" width="48" height="48" [src]="id | image : imageType : hasPhoto" class="avatar-md"
    onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'" [ngClass]="{
      'avatar-sm': size === 'small',
      '!w-12 !h-12': size === 'large',
      'w-full h-full': size !== 'small'
    }" [alt]="alt" />
</ng-template>